import { clsx } from 'clsx'
import { Link } from './Link'

const variants = {
  primary: clsx(
    'inline-flex items-center justify-center px-4 py-[calc(--spacing(2)-1px)]',
    'rounded-full border border-transparent bg-gray-950 shadow-md',
    'text-base font-medium whitespace-nowrap text-white',
    'transition duration-200 hover:bg-gray-800 hover:shadow-lg active:scale-[0.98] active:bg-gray-900 active:shadow-md',
    'focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600',
    'disabled:opacity-40 disabled:hover:bg-gray-950 disabled:hover:shadow-md disabled:active:scale-100',
  ),
  secondary: clsx(
    'relative inline-flex items-center justify-center px-4 py-[calc(--spacing(2)-1px)]',
    'rounded-full border border-transparent bg-white/15 shadow-md ring-1 ring-black/10',
    'after:absolute after:inset-0 after:rounded-full after:shadow-[inset_0_0_2px_1px_#ffffff4d]',
    'text-base font-medium whitespace-nowrap text-gray-950',
    'transition hover:bg-white/25 active:scale-[0.98]',
    'focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600',
    'disabled:opacity-40 disabled:active:scale-100',
  ),
  outline: clsx(
    'inline-flex items-center justify-center px-2 py-[calc(--spacing(1.5)-1px)]',
    'rounded-lg border border-transparent shadow-xs ring-1 ring-black/10',
    'text-sm font-medium whitespace-nowrap text-gray-950',
    'transition hover:bg-gray-50',
    'focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600',
    'disabled:opacity-40',
  ),
}

type ButtonProps = { variant?: keyof typeof variants } & (
  | ({ href: string } & Omit<React.ComponentPropsWithoutRef<typeof Link>, 'href'>)
  | ({ href?: undefined } & React.ComponentPropsWithoutRef<'button'>)
)

export function Button({
  variant = 'primary',
  className,
  ...props
}: ButtonProps) {
  className = clsx(className, variants[variant])

  if (typeof props.href === 'undefined') {
    return (
      <button
        {...(props as React.ComponentPropsWithoutRef<'button'>)}
        className={className}
      />
    )
  }

  return <Link {...props} className={className} />
}
